import { render, staticRenderFns } from "./cabinets.vue?vue&type=template&id=43f0950e&scoped=true&lang=pug&"
import script from "./cabinets.vue?vue&type=script&lang=js&"
export * from "./cabinets.vue?vue&type=script&lang=js&"
import style0 from "./cabinets.vue?vue&type=style&index=0&id=43f0950e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f0950e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
